import React from "react";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#E2E8F0] bg-[#F8F9FA] mt-16"
        >
            <div className="max-w-6xl mx-auto px-6 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#64748B]">
                <p>
                    This page helps candidates apply the correct booking code
                    when registering for LanguageCert exams.
                </p>
                <p data-testid="footer-copyright">
                    © {new Date().getFullYear()} LanguageCert codes reference
                </p>
            </div>
        </footer>
    );
};

export default Footer;
